if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.countryList = document.querySelector('#country-list');
        this.trigger = this.querySelector('#localization-form-trigger');
        this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
        this.trigger.addEventListener('click', this.onTriggerClick.bind(this));
        document.body.addEventListener('click', this.onClickOutsideCountryList.bind(this));
      }

      onClickOutsideCountryList(event) {
        //if the country list is open
        if (this.countryList.classList.contains('grid-rows-[1fr]')) {
          //if the click is outside country list and trigger
          if (!this.countryList.contains(event.target) && !this.trigger.contains(event.target)) {
            this.trigger.click();
          }
        }
      }

      onItemClick(event) {
        if (event.currentTarget.getAttribute('data-value')) event.preventDefault();
        this.querySelector('input[name="locale_code"], input[name="country_code"]').value = event.currentTarget.dataset.value;
        const form = this.querySelector('#localization_form');
        if (form) form.submit();
      }

      onTriggerClick(event) {
        event.preventDefault();
        this.countryList.classList.toggle('grid-rows-[0fr]');
        this.countryList.classList.toggle('grid-rows-[1fr]');
        const links = this.querySelectorAll('a');
        links.forEach(item => {
          this.toggleTabbable(item);
        });
      }

      toggleTabbable(element) {
        if (element.getAttribute('tabindex') < 0) {
          element.setAttribute('tabindex', '0');
        } else {
          element.setAttribute('tabindex', '-1');
        }
      }
    }
  );
}